import { jsx as e, jsxs as a, Fragment as w } from "react/jsx-runtime";
import { UtilityChevronIcon as z } from "./index.es439.js";
import { BodyText as B } from "./index.es505.js";
import N from "classnames";
import { forwardRef as j, isValidElement as v, useCallback as V } from "react";
import i from "./index.es842.js";
import { ColorIndicator as E } from "./index.es32.js";
import { FlexContainer as m } from "./index.es584.js";
import { Link as F } from "./index.es68.js";
import { Divider as S } from "./index.es24.js";
import { Icon as T } from "./index.es157.js";
const L = j(
  ({
    LeftIcon: d,
    size: p = "default",
    value: t,
    placeholder: l = "Select",
    disabled: r,
    isError: f,
    testId: o,
    isOpen: h,
    isLocked: n,
    entityColor: s,
    colorIndicator: g,
    showClearIndicator: x,
    onClearClick: c
  }, u) => {
    const I = (t || l) && !v(t), y = N(
      i.default,
      i.select,
      i[`size-${p}`],
      {
        [i.selected]: !!t,
        [i.error]: f,
        [i.disabled]: r,
        [i.colorIndicator]: !!s
      }
    ), b = V(
      ($) => {
        $.stopPropagation(), c == null || c();
      },
      [c]
    );
    return /* @__PURE__ */ e("div", { "aria-disabled": r, ref: u, children: /* @__PURE__ */ a(
      "div",
      {
        className: y,
        tabIndex: 0,
        "data-testid": o,
        "aria-disabled": r,
        "data-pl-identifier": "select-box",
        children: [
          !!s && /* @__PURE__ */ e(
            E,
            {
              thickness: "thin",
              testId: `${o}-color-indicator`,
              disabled: r,
              color: g,
              entityColor: s
            }
          ),
          !s && d,
          /* @__PURE__ */ e("div", { className: i.value, children: I ? /* @__PURE__ */ e(
            B,
            {
              testId: `${o}-value`,
              size: "default",
              variant: t && !r ? "semi-bold" : "regular",
              color: r ? "disabled" : t ? "primary" : "gray",
              isEllipsis: !0,
              element: "p",
              children: t || l
            }
          ) : t }),
          /* @__PURE__ */ a(
            m,
            {
              alignItems: "center",
              gap: "8px",
              height: "100%",
              justifyContent: "space-between",
              children: [
                x && !n && t && /* @__PURE__ */ a(w, { children: [
                  /* @__PURE__ */ e(
                    F,
                    {
                      weight: "semi-bold",
                      size: "small",
                      onClick: b,
                      testId: `${o}-clear-icon`,
                      children: "Clear"
                    }
                  ),
                  /* @__PURE__ */ e("div", { style: { padding: "10px 0", height: "100%" }, children: /* @__PURE__ */ e(S, { isVertical: !0 }) })
                ] }),
                /* @__PURE__ */ e(
                  m,
                  {
                    alignItems: "center",
                    testId: `${o}-${n ? "lock" : "chevron"}-icon`,
                    children: n ? /* @__PURE__ */ e(T, { size: 16, type: "Lock", testId: "lock-icon" }) : /* @__PURE__ */ e(
                      z,
                      {
                        direction: h ? "up" : "down",
                        outline: r ? "disabled" : "default-gray",
                        type: "bold"
                      }
                    )
                  }
                )
              ]
            }
          )
        ]
      }
    ) });
  }
);
export {
  L as BasicSelectBox
};
//# sourceMappingURL=index.es843.js.map
